// export const API_BASE_URL = 'http://192.168.1.180:5000/api';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';